/**
 * @generated SignedSource<<42fd8c7a3069c7d6d108b205dd9fe7cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductRole = "instructor" | "manager" | "member" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProductMembersCardViewDashboardBlock_productMemberships_PaginationFragment$data = {
  readonly id: string;
  readonly productMemberships: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "ProductMembership";
        readonly id: string;
        readonly member: {
          readonly bio: string;
          readonly fullName: string;
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"ProfileAvatarWithDetailsFragment">;
        };
        readonly role: ProductRole;
      };
    }>;
    readonly totalCount: number;
  };
  readonly " $fragmentType": "ProductMembersCardViewDashboardBlock_productMemberships_PaginationFragment";
};
export type ProductMembersCardViewDashboardBlock_productMemberships_PaginationFragment$key = {
  readonly " $data"?: ProductMembersCardViewDashboardBlock_productMemberships_PaginationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductMembersCardViewDashboardBlock_productMemberships_PaginationFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "productMemberships"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "productRoles"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./ProductMembersCardViewDashboardBlock_productMemberships_PaginationQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "ProductMembersCardViewDashboardBlock_productMemberships_PaginationFragment",
  "selections": [
    {
      "alias": "productMemberships",
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": {
            "direction": "DESC",
            "field": "last_activity_at"
          }
        },
        {
          "kind": "Variable",
          "name": "roles",
          "variableName": "productRoles"
        }
      ],
      "concreteType": "ProductMembershipNodeConnection",
      "kind": "LinkedField",
      "name": "__ProductMembersCardViewDashboardBlock__productMemberships_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductMembershipNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductMembership",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "role",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "member",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bio",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fullName",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ProfileAvatarWithDetailsFragment"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfoObjectType",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "Product",
  "abstractKey": null
};
})();

(node as any).hash = "7fc85329a32fa26e9ed4e6d30b0bf377";

export default node;
